import React, { useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Box, Button, Stack, Pagination } from '@mui/material';
import { styled } from '@mui/material/styles';
import { tableCellClasses } from '@mui/material/TableCell';
import { createStyles, withStyles } from '@mui/styles';
import { DateConverter } from '../../utils/DateConverter';
import ApproveModal from '../../reusable-component/ApproveModal';
import RejectModal from '../../reusable-component/RejectModal';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    background: 'none !important',
    color: '#8798AD',
    padding: '10px',
    textTransform: 'uppercase',
    fontSize: 12,
    fontWeight: 600,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: '15px',
  },
}));

const StyledTableRow = withStyles((theme) =>
  createStyles({
    root: {
      border: '1px solid red',
      background: '#FFFFFF',
      boxShadow: '0px 2px 6px #0000000A',
      borderRadius: '5px !important',
    },
  })
)(TableRow);

export default function UserTable({ tableData, pagination, onPageChange }) {
  const [openApproveModal, setOpenApproveModal] = React.useState(false);
  const [openRejectModal, setOpenRejectModal] = React.useState(false);
  const [message, setMessage] = React.useState('');
  const [userId, setUserId] = React.useState('');

  const totalPages = Math.ceil(pagination.total / pagination.size);

  const handleChangePage = (event, newPage) => {
    onPageChange(newPage - 1);
  };

  const handleApproveModal = (row) => {
    setOpenApproveModal(!openApproveModal);
    if (!openApproveModal) {
      setMessage(`Approve user "${row.username}"?`);
      setUserId(row.user_id);
    }
  };

  const handleRejectModal = (row) => {
    setOpenRejectModal(!openRejectModal);
    if (!openRejectModal) {
      setMessage(`Reject user "${row.username}"?`);
      setUserId(row.user_id);
    }
  };

  return (
    <Box>
      <TableContainer>
        <Table style={{ minWidth: 650, borderSpacing: '0px 4px', borderCollapse: 'separate' }}>
          <TableHead>
            <TableRow>
              <StyledTableCell>Name</StyledTableCell>
              <StyledTableCell>Email</StyledTableCell>
              <StyledTableCell>Role</StyledTableCell>
              <StyledTableCell>Signed Up On</StyledTableCell>
              <StyledTableCell>Action</StyledTableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {tableData.map((row) => (
              <StyledTableRow key={row.user_id}>
                <StyledTableCell>{row.username}</StyledTableCell>
                <StyledTableCell>{row.email}</StyledTableCell>
                <StyledTableCell>{row.role}</StyledTableCell>
                <StyledTableCell>{DateConverter(row.creation_date)}</StyledTableCell>

                <StyledTableCell>
                  <Stack direction="row" spacing={2}>
                    <Button size="small" variant="contained" sx={{ background: '#27CC00' }}
                      onClick={() => handleApproveModal(row)}>Approve</Button>

                    <Button size="small" variant="contained" color="error"
                      onClick={() => handleRejectModal(row)}>Reject</Button>
                  </Stack>
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <ApproveModal
        openApproveModal={openApproveModal}
        handleApproveModal={handleApproveModal}
        fetchData={() => onPageChange(0)}
        type="user"
        id={userId}
        message={message}
      />

      <RejectModal
        openRejectModal={openRejectModal}
        handleRejectModal={handleRejectModal}
        fetchData={() => onPageChange(0)}
        type="user"
        id={userId}
        message={message}
      />

      <Pagination
        count={Math.ceil(pagination.total / pagination.size)}
        page={pagination.page + 1}
        onChange={handleChangePage}
        variant="outlined"
        shape="rounded"
        size="small"
        sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}
      />
    </Box>
  );
}
